import { QUOTE_VALIDITY_DAYS_UNLIMITED } from 'features/Work/constants';
import { QuoteFormSchema } from 'features/Work/form/quoteForm.schema';

import { RetrievedQuote } from '../../../hooks/queries/useRetrievedQuoteQuery';

export const formatRetrievedQuote = (
  quote: RetrievedQuote,
): Omit<QuoteFormSchema, 'lastEditedAt'> => {
  const tasks = quote.tasks.map(({ __typename, ...task }) => task);

  const { __typename: settingsTypename, ...restSettings } = quote.settings;

  return {
    clientId: quote.clientId,
    companyProfileId: quote.companyProfileId,
    currency: quote.currency,
    fiscalId: quote.fiscalId,
    lateFeePercentage: quote.lateFeePercentage,
    lateMaxDays: quote.lateMaxDays,
    settings: {
      ...restSettings,
      quoteValidityDays:
        restSettings.quoteValidityDays === QUOTE_VALIDITY_DAYS_UNLIMITED
          ? null
          : restSettings.quoteValidityDays,
    },
    startAt: quote.startAt,
    subtitle: quote.subtitle,
    tasks,
    title: quote.title,
  };
};
